import React from 'react'

export const InputProcessingLoader = () => (
  <div className='[ f-pos-ab ] QuizApp-transition-loader-wrap'>
    <div className='[ f-m-h-auto ] QuizApp-transition-loader' />
    <div className='[ f-t-tbody f-m-h-auto f-m-t-020 f-t-centre ] QuizApp-transition-loader-copy'>
      Eingabe wird verarbeitet…
    </div>
  </div>
)
